import React, { useEffect, useState, useRef } from "react";

import moment from "moment";

import { useUser, useLang } from "../zustand/store.js";

import { TableVirtuoso, Virtuoso } from 'react-virtuoso';
import { toast } from 'react-toastify';

import routes from "../libs/routes";
import images from "../libs/images";
import consts from "../libs/consts";

import { numFormat, errorMessage } from "../utils/utils";
import * as APIS from "../utils/service";

import Image from '../components/Image';
import InputFile from '../components/InputFile';
import Input from '../components/Input';
import InputSimple from '../components/InputSimple';
import Selector from '../components/Selector';
import Button from '../components/Button';
import ContainerLoader from '../components/ContainerLoader';
import Skeleton from '../components/Skeleton';


import { LangText } from "../zustand/dict.js";
import { useNavigate } from "react-router-dom";

// import { lang } from '../utils/utils';

export default function PayHistory() {
    const navigate = useNavigate();
    const ref = useRef(null);
    const emailref = useRef();
    // const hpref = useRef();
    // const pwref = useRef();
    // const repwref = useRef();
    // const nickref = useRef();

    const { user, reload } = useUser();
    const { country, getLang } = useLang();

    const [list, setlist] = useState([]);
    const [pageToken, setPageToken] = useState("");
    // const [viewlist, setviewlist] = useState([]);
    // const [pagerows, setpagerows] = useState(consts.pagerows);

    const [selected, setselected] = useState('');
    const [stx, setstx] = useState('');
    const [searchData, setsearchData] = useState({ type: 0, value: "" });

    const [error, setError] = useState({});

    const [load, setLoad] = useState(false);

    useEffect(() => {
        dataFunc();
    }, []);


    const dataFunc = () => {
        let sender = {
            pageToken: pageToken,
            limit: 10,
            type: 0,
            date: "",
            menuName: "",
        }

        if (searchData) {
            if (searchData.type == 1) {
                sender.date = searchData.value
            } else if (searchData.type == 2) {
                sender.menuName = searchData.value
            } else if (searchData.type == 3 || searchData.type == 4) {
                sender.type = searchData.value
            }
        }


        setLoad(true)
        APIS.post('/user/creditHistory', sender).then(({ data }) => {
            if (data?.list) { setlist(v => v.concat(data?.list)); }
            if (data?.pageToken) {
                setPageToken(data?.pageToken)
            } else {
                setPageToken("")
            }
            setLoad(false)
        }).catch(({ response }) => {
            setLoad(false)
        }).finally(() => {
        });
    }

    const handleKeyDown = (e) => {
        if (e?.key === 'Enter') {
            searchFunc()
        }
    };

    const searchFunc = () => {
        let value = stx ? stx : "";
        if (selected == 1) {
            setlist([])
            setPageToken("")
            setsearchData({
                type: 1,
                value: value
            })
        } else if (selected == 2) {
            setlist([])
            setPageToken("")
            setsearchData({
                type: 2,
                value: value
            })
        } else if (selected == 3) {
            setlist([])
            setPageToken("")
            setsearchData({
                type: 3,
                value: 1
            })
        } else if (selected == 4) {
            setlist([])
            setPageToken("")
            setsearchData({
                type: 3,
                value: 2
            })
        }
    }

    useEffect(() => {
        dataFunc();
    }, [searchData])

    const loadMore = () => {
        if (pageToken && !load) {
            setLoad(true)
            setTimeout(() => {
                dataFunc(searchData)
            }, 1000)
        }
    }

    return (
        <>
            <div className="content">
                <div className="title_box">
                    <p className="title"><LangText id={'text_credit_history'} /></p>
                    <p className="sub_title"><LangText id={'text_credit_used_history'} /></p>
                </div>
                <div className="list_table">
                    <div className="list_table_top">
                        <p className="title"><LangText id={'text_credit_history_search'} /></p>
                        <div className="filter_box">
                            <Selector
                                options={[
                                    // { value: 1, label: "날짜(yyyy-mm-dd)" },
                                    // { value: 2, label: "한글메뉴명" },
                                    // { value: 3, label: "사용크레딧" },
                                    // { value: 4, label: "충전크레딧" },
                                    { value: 1, label: <><LangText id={'text_date'} />(yyyy-mm-dd)</> },
                                    { value: 2, label: <LangText id={'text_menu_name'} /> },
                                    { value: 3, label: <LangText id={'text_used'} /> },
                                    { value: 4, label: <LangText id={'text_chage'} /> },
                                ]}
                                placeholder={<LangText id={'text_select'} />}
                                value={selected}
                                setValue={setselected}
                            />
                            {[1, 2].includes(selected) && <InputSimple
                                name="stx"
                                value={stx}
                                setValue={setstx}
                                onKeyDown={handleKeyDown}
                                placeholder={getLang({ key: 'placeholder_search' })}
                                error={error}
                                setError={setError} />}
                            <Button title={<LangText id={'btn_search'} />} onClick={searchFunc} />
                        </div>
                    </div>

                    <div className="table_style_1" style={{ "--colums": '20%' }}>
                        <TableVirtuoso
                            ref={ref}
                            useWindowScroll
                            endReached={() => {
                                if (list.length > 0) {
                                    loadMore();
                                }
                            }}
                            initialTopMostItemIndex={0}
                            // data={viewlist?.filter(pageFunc)}
                            data={list}
                            fixedHeaderContent={(index, user) => (
                                <tr>
                                    <th className={''} ><LangText id={'text_date'} /></th>
                                    <th className={''} ><LangText id={'text_menu_name'} /></th>
                                    <th className={''} ><LangText id={'text_used'} /></th>
                                    <th className={''} ><LangText id={'text_chage'} /></th>
                                    <th className={''} ><LangText id={'text_show_work'} /></th>
                                </tr>
                            )}
                            itemContent={(index, item) => (
                                <>
                                    {/* <td>{index}</td>
                                    <td>{index}aaaa</td>
                                    <td>{index}bbb</td>
                                    <td>{index}ccc</td>
                                    <td>{index}ddd</td> */}
                                    <td>{moment(item?.createAt).format("YYYY-MM-DD HH:mm:ss")}</td>
                                    <td>{getLang({ key: item?.name_key })}</td>
                                    <td>{item?.type == 1 ? item?.use_point : "-"}</td>
                                    <td>{item?.type == 2 ? item?.add_point : "-"}</td>
                                    <td>
                                        {item?.type == 1 && <Button type={2} title={<LangText id={'btn_show'} />} onClick={() => {
                                            navigate("/myart_history", {
                                                state: {
                                                    menuId: item.menuId,
                                                    artIdx: item.targetId
                                                }
                                            })
                                        }} />}
                                    </td>
                                </>
                            )}
                        />
                        {/* {(viewlist?.length > pagerows || load) && (
                            <div className={`table_loading ${load ? 'init' : ''}`}>
                                <div className="loading_spin"></div>
                            </div>
                        )} */}
                        {(load) && (
                            <div className={`table_loading ${load ? 'init' : ''}`}>
                                <div className="loading_spin"></div>
                            </div>
                        )}
                    </div>

                    <div className="table_style_2">
                        <Virtuoso
                            style={{ width: "100%" }}
                            ref={ref}
                            useWindowScroll
                            endReached={() => {
                                loadMore();
                            }}
                            initialTopMostItemIndex={0}
                            data={list}
                            itemContent={(index, item) => (
                                <div className="list_item">
                                    <div className="info_box">
                                        <div className="info_item">
                                            <p className="body2"><LangText id={'text_date'} /></p>
                                            <p className="body2 rg">{moment(item?.createAt).format("YYYY-MM-DD HH:mm:ss")}</p>
                                        </div>
                                        <div className="info_item">
                                            <p className="body2"><LangText id={'text_menu_name'} /></p>
                                            <p className="body2 rg">{getLang({ key: item?.name_key })}</p>
                                        </div>
                                        <div className="info_item">
                                            <p className="body2"><LangText id={'text_used'} /></p>
                                            <p className="body2 rg">{item?.type == 1 ? item?.use_point : "-"}</p>
                                        </div>
                                        <div className="info_item">
                                            <p className="body2"><LangText id={'text_chage'} /></p>
                                            <p className="body2 rg">{item?.type == 2 ? item?.add_point : "-"}</p>
                                        </div>
                                    </div>
                                    {item?.type === 1 && <div className="btn_box">
                                        <Button type={2} title={<LangText id={'btn_show'} />} onClick={() => {
                                            navigate("/myart_history", {
                                                state: {
                                                    menuId: item.menuId,
                                                    artIdx: item.targetId
                                                }
                                            })
                                        }} />
                                    </div>}
                                </div>
                            )}
                        />
                        {(load) && (
                            <div className={`table_loading ${load ? 'init' : ''}`}>
                                <div className="loading_spin"></div>
                            </div>
                        )}
                    </div>

                </div>

            </div>
        </>
    );
}
